import React from 'react';
import { useAuthContext } from 'src/context/authContext';
import { RoundedImage } from 'src/shared/ui/widgets/RoundedImage';

export const HeaderUserAvatar: React.FC = () => {
  const { currentUser } = useAuthContext();

  return <RoundedImage name={currentUser.name} url={currentUser.avatarUrl} />;
};
